import { render } from "./SiteTextInner.vue?vue&type=template&id=2d477378"
import script from "./SiteTextInner.vue?vue&type=script&lang=js"
export * from "./SiteTextInner.vue?vue&type=script&lang=js"

import "./SiteTextInner.vue?vue&type=style&index=0&id=2d477378&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__